import { colorSchemes } from "@nivo/colors";

export default function getColorsForScheme(
  schemeName: string,
  count: number
): string[] {
  const scheme = colorSchemes[schemeName as keyof typeof colorSchemes];
  if (!scheme) {
    console.warn(
      `Color scheme "${schemeName}" não encontrado. Usando "nivo" como fallback.`
    );
    // Fallback para "nivo"
    return Array.from(
      { length: count },
      (_, i) => colorSchemes.nivo[i % colorSchemes.nivo.length]
    );
  }

  // Se o primeiro elemento for uma string, o scheme é flat (ex.: "nivo")
  if (typeof scheme[0] === "string") {
    return Array.from(
      { length: count },
      (_, i) => (scheme as string[])[i % scheme.length]
    );
  } else {
    // Para schemes aninhados (ex.: "purpleRed_green")
    // Tenta pegar a paleta com exatamente "count" cores
    let availableColors = (scheme as string[][])[
      (scheme as string[][]).length - 1
    ];
    // Se não existir paleta para essa quantidade ou se for null, procura pelo maior disponível
    if (!availableColors) {
      for (let i = (scheme as string[][]).length - 1; i >= 0; i--) {
        if ((scheme as string[][])[i] !== null) {
          availableColors = (scheme as string[][])[i];
          break;
        }
      }
    }
    // Se mesmo assim não houver, usamos "nivo" como fallback
    if (!availableColors) {
      availableColors = colorSchemes.nivo as string[];
    }
    // Se a quantidade de itens exceder o tamanho da paleta, utiliza o operador módulo
    return Array.from(
      { length: count },
      (_, i) => availableColors[i % availableColors.length]
    );
  }
}
